import xlsx from 'xlsx'

export function buildExportSheetRows(rows, { includeSelected = false } = {}) {
  return (rows || []).map((row, index) => {
    const base = {
      STT: index + 1,
      IMEI: row.imeiCode || row.imeiNo || '',
    }
    if (includeSelected) {
      base['Đã chọn'] = row.selected ? 'Y' : 'N'
    }
    return base
  })
}

export function downloadImeiTemplate(filename = 'Mau_IMEI') {
  const wb = xlsx.utils.book_new()
  const ws = xlsx.utils.json_to_sheet([{ STT: 1, IMEI: '' }])
  xlsx.utils.book_append_sheet(wb, ws, 'IMEI')
  xlsx.writeFile(wb, `${filename}.xlsx`)
}

export function exportImeisToExcel(rows, filename, options = {}) {
  const sheetRows = buildExportSheetRows(rows, options)
  if (!sheetRows.length) {
    return false
  }
  const wb = xlsx.utils.book_new()
  const ws = xlsx.utils.json_to_sheet(sheetRows)
  xlsx.utils.book_append_sheet(wb, ws, 'IMEI')
  xlsx.writeFile(wb, `${filename}.xlsx`)
  return true
}

export function buildImeiExportFilename(productCode) {
  const code = (productCode || 'IMEI').replace(/[^\w-]+/g, '_')
  const ts = new Date()
  const pad = (n) => String(n).padStart(2, '0')
  const stamp = `${ts.getFullYear()}${pad(ts.getMonth() + 1)}${pad(ts.getDate())}_${pad(ts.getHours())}${pad(ts.getMinutes())}`
  return `IMEI_${code}_${stamp}`
}
